var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-ml-4 tw-mr-4 tw-mb-4"},[_c('div',{class:{
        'tw-capitalize': true,
        'inactive-text': !_vm.filterText,
        'tw-whitespace-no-wrap': true,
        'tw-font-bold': true
      }},[_vm._t("default")],2),_c('v-btn',{staticClass:"edit-filter text-capitalize tw-block tw-max-w-full",attrs:{"small":"","outlined":"","block":"","color":"primary","disabled":_vm.disabled},on:{"click":(e) => _vm.$emit('click', e)}},[_c('span',{staticClass:"tw-font-bold tw-truncate"},[_vm._v(_vm._s(_vm.filterText))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }